import { Link } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi2";

function ApplyNowCta({
  eyebrow = "Admissions",
  heading = "Apply now for the upcoming academic year",
  description = "Complete our application or reach out—we will help you choose the right stream and get started with confidence.",
  primaryHref = "https://forms.gle/m1PLhs8jVYXHs1cWA",
  primaryLabel = "Apply now",
  secondaryHref = "/admission-process",
  secondaryLabel = "See admission process",
  headingId = "apply-now-cta-heading",
}) {
  return (
    <section
      className="relative overflow-hidden py-14 sm:py-16 lg:py-20"
      aria-labelledby={headingId}
    >
      <div
        className="absolute inset-0 bg-gradient-to-br from-brand-dark via-brand to-[#352966]"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -left-20 top-0 h-72 w-72 rounded-full bg-brand-accent/20 blur-3xl"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -right-16 bottom-0 h-64 w-64 rounded-full bg-white/10 blur-3xl"
        aria-hidden
      />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center lg:gap-12">
          <div className="min-w-0 max-w-2xl">
            {eyebrow ? (
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand-accent sm:text-[0.8125rem]">
                {eyebrow}
              </p>
            ) : null}
            <h2
              id={headingId}
              className="mt-3 text-balance text-2xl font-bold tracking-tight text-white sm:mt-4 sm:text-3xl md:text-[2rem] md:leading-tight"
            >
              {heading}
            </h2>
            {description ? (
              <p className="mt-4 text-pretty text-base leading-relaxed text-white/80 sm:text-lg">
                {description}
              </p>
            ) : null}
          </div>

          <div className="flex w-full shrink-0 flex-col gap-3 sm:w-auto sm:flex-row sm:items-center sm:gap-4">
            <Link
              to={primaryHref}
              className="group inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-7 py-3.5 text-center text-sm font-semibold text-brand shadow-lg shadow-black/15 transition hover:bg-brand-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:text-base"
            >
              {primaryLabel}
              <HiArrowRight
                className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-0.5"
                aria-hidden
              />
            </Link>
            <Link
              to={secondaryHref}
              className="inline-flex items-center justify-center rounded-2xl border-2 border-white/35 bg-transparent px-7 py-3.5 text-center text-sm font-semibold text-white transition hover:border-white/55 hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:text-base"
            >
              {secondaryLabel}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ApplyNowCta;
